import {hostByBrandByEnv} from '../../../../../hosts'
import {CSP} from '../../../../constants'
import type {Preset} from '../../../../types'

export const API_PASSPORT = {
  [CSP.CONNECT]: [hostByBrandByEnv.yandex.production.passport.api],
} as const satisfies Preset
